<script>
import { Overlay } from '../../'
import Price from './price.js'

export default {
    name: 'VT',
    props: [
        'data', 'sub', 'tf'
    ],
    mixins: [Overlay],
    data() {
        return {
            trend: {}
        }
    },
    computed: {
        sett() {
            return this.$props.settings
        },
        price_line() {
            return 'priceLine' in this.sett ?
                this.sett.priceLine : true
        },
        risk_reward_ratio() {
            return this.sett.riskRewardRatio || 3
        },
        sma_length() {
            return this.sett.smaLength || 50
        },
        dc_length() {
            return this.sett.dcLength || 20
        },
        show_pending_target() {
            return this.sett.showPendingTarget || true
        },
        show_immediate_target() {
            return this.sett.showImmediateTarget || true
        },
        show_safe_target() {
            return this.sett.showSafeTarget || false
        },
        show_highlight_entry() {
            return this.sett.showHighlightEntry || true
        },
        default_font() {
            return '12px ' + this.$props.font.split('px').pop()
        },
        currency_symbol() {
            return this.sett.currency || '₹'
        },
        long_color() {
            return this.sett.longColor || 'rgba(99, 223, 137, 0.6)' // '#63df89'
        },
        short_color() {
            return this.sett.shortColor || 'rgba(255, 213, 129, 0.6)' // '#ffd581'
        },
        long_cover_color() {
            return this.sett.longCoverColor || 'rgba(252, 126, 47, 0.6)' // '#fc7e2f'
        },
        short_cover_color() {
            return this.sett.shortCoverColor || 'rgba(255, 107, 214, 0.6)' // '#ff6bd6'
        },
        label_color() {
            return this.sett.labelColor || 'rgba(75, 236, 249, 0.6)' // '#4BECF9'
        },
        upBarColor() {
            return this.sett.upBarColor || "rgb(38, 166, 154)"
        },
        downBarColor() {
            return this.sett.downBarColor || "rgb(239, 83, 80)"
        },
        pendingTargetColor() {
            return this.sett.pendingTargetColor || "rgb(92, 92, 92)"
        },
        is_dark() {
            const back = this.$props.colors ? this.$props.colors.back : ''
            return back && back !== '#fff' && back !== '#ffffff' && back !== 'white'
        },
        marker_size() {
            return this.sett.markerSize || 5
        },
        show_label() {
            return this.sett.showLabel !== false
        },
        new_font() {
            return this.sett.font || this.default_font
        },
        current_trend() {
           return this.trend || this.$props.trend || {}
        }
    },
    methods: {
        meta_info() {
            return {
                author: 'Mano',
                version: '1.0.0',
                desc: 'VisualTrading',
                preset: {
                    name: 'Target, $smaLength $dcLength $riskRewardRatio',
                    side: 'onchart',
                    settings: {
                        "smaLength": this.sma_length,
                        "dcLength": this.dc_length,
                        "riskRewardRatio": this.risk_reward_ratio,
                        "showImmediateTarget": this.show_immediate_target,
                        "showPendingTarget": this.show_pending_target,
                        "showSafeTarget": this.show_safe_target,
                        "showHighlightEntry": this.show_highlight_entry,
                    }
                }
            }
        },
        init() {
            this.price = new Price(this)
        },
        draw(ctx) {
            let layout = this.$props.layout
            ctx.lineWidth = 0.5
            ctx.strokeStyle = 'black'

            let fill = this.is_dark ? "#2a3040" : "#d9d9d9"
            let fillOpacity = this.is_dark ? 0.6 : 0.8
            let strokeOpacity = this.is_dark ? 0.6 : 0.8

            var plotA = []

            var i = 0, j = 0
            var entry = {}
            var clearEntry = true
            var pendingTargetB = 0
            var pendingTargetS = 0

            var lastEntry
            var lastCandle

            var entryDirection
            var entryPoint
            var entrySL
            var entryTarget
            var signal = {}
            var blackCandle
            var trendChanged
            var prev
            var starFormed
            var blackCandleFormed
            var fractalHigh
            var fractalLow
            var bigKuchi = 0
            var kuchiEntry

            var trend = {}
            var data = this.processVTSignals(this.$props.sub.full_data, trend, true)
            this.trend = trend

            for (var p of data) {

                let now = p
                let open = p.open
                let high = p.high
                let low  = p.low
                let close = p.close
                let nowTrend = now.trend
                let prevTrend = prev ? prev.trend : ""
                let level = 0
                let range = 0

                let candleSize = high - low
                let bodySize
                let upperKuchi
                let lowerKuchi
                let kuchi
                let kuchiSize;
                if (open > close) {
                    bodySize = open - close
                    upperKuchi = high - open
                    lowerKuchi = close - low
                }
                else {
                    bodySize = close - open
                    upperKuchi = high - close
                    lowerKuchi = open - low
                }
                if (lowerKuchi > upperKuchi) {
                    kuchi = lowerKuchi
                    if (now.fractalLow > 0) {
                        now.kuchi = kuchi
                    }
                } else {
                    kuchi = upperKuchi
                    if (now.fractalHigh > 0) {
                        now.kuchi = kuchi
                    }
                }

                if (now.kuchi && now.fractalHigh > 0 && now.fractalLow > 0) {
                  if (bigKuchi < now.kuchi) {
                      bigKuchi = now.kuchi
                      kuchiEntry = now
                  }
                }

                if (now.entryDirection === "BUY") {
                   level = now.entryPoint - now.entryStoploss
                   range = now.entryTarget - now.entryPoint
                   var t1 = now.entryPoint + level
                   var t2 = now.entryPoint + (level * 2)
                   var mid =  now.entryPoint + (range / 2)
                   //now.entryTarget = now.entryPoint + range
                   now.entryTarget1 = t1
                   now.entryTarget2 = t2
                   now.entryTargetMid = mid
                } else if (now.entryDirection === "SELL") {
                   level = now.entryStoploss - now.entryPoint
                   range = now.entryPoint - now.entryTarget
                   var t1 = now.entryPoint - level
                   var t2 = now.entryPoint - (level * 2)
                   var mid =  now.entryPoint - (range / 2)
                   //now.entryTarget = now.entryPoint - range
                   now.entryTarget1 = t1
                   now.entryTarget2 = t2
                   now.entryTargetMid = mid
                }

                if (now.entryDirection === "BUY" && (clearEntry || now.trendChanged)) {
                    entry = now
                    entry.startIdx = Math.round(layout.t2screen(now.date))
                    entry.endIdx = Math.round(layout.t2screen(now.date))
                    if (pendingTargetB > now.entryTarget)
                    {
                        entry.pendingTarget = pendingTargetB
                    }
                    if (now.open < entry.entryPoint && now.close > entry.entryPoint && now.high < now.entryTargetMid) {
                        entry.safeEntry = now.high
                        entry.safeTarget = entry.safeEntry + level
                    }
                    lastEntry = entry
                    pendingTargetB = now.entryTarget
                    plotA[i] = entry
                    clearEntry = false
                } else if (now.entryDirection === "SELL" && (clearEntry || now.trendChanged)) {
                    entry = now
                    entry.startIdx = Math.round(layout.t2screen(now.date))
                    entry.endIdx = Math.round(layout.t2screen(now.date))
                    if (pendingTargetS < now.entryTarget)
                    {
                        entry.pendingTarget = pendingTargetS
                    }
                    if (now.open > entry.entryPoint && now.close < entry.entryPoint && now.low > now.entryTargetMid) {
                        entry.safeEntry = now.low
                        entry.safeTarget = entry.safeEntry - level
                    }
                    pendingTargetS = now.entryTarget
                    plotA[i] = entry
                    lastEntry = entry
                    clearEntry = false
                } else {
                    if (entry.entryDirection === "BUY" && !clearEntry && !now.trendChanged) {
                        entry.endIdx = Math.round(layout.t2screen(now.date))
                        plotA[i] = entry
                    } else if (entry.entryDirection === "SELL" && !clearEntry && !now.trendChanged) {
                        entry.endIdx = Math.round(layout.t2screen(now.date))
                        plotA[i] = entry
                    } else if (now.trendChanged) {
                        entry = { endIdx: Math.round(layout.t2screen(now.date)) }
                        plotA[i] = entry
                        clearEntry = true
                    } else {
                        entry = { endIdx: Math.round(layout.t2screen(now.date)) }
                        plotA[i] = entry
                        clearEntry = true
                     }
                }
                prev = now
                i++
            }

            let canvasGradient = null
            let canvasClip = false

            if (canvasGradient != null) {
              ctx.fillStyle = canvasGradient(this.$props, ctx)
            } else {
              ctx.fillStyle = this.hexToRGBA(fill, fillOpacity)
            }
            if (canvasClip) {
              ctx.save()
              //canvasClip(ctx, this.$props)
            }
            //ctx.lineWidth = hovering ? hoverStrokeWidth : strokeWidth

            //ctx.setLineDash(getStrokeDasharray(strokeDasharray).split(","))
            const red = this.is_dark ? "rgba(239, 83, 80, 0.5)" : "rgb(245, 183, 177)"
            const darkGreen = this.is_dark ? "rgba(38, 166, 154, 0.9)" : "rgb(18, 124, 63)"
            const darkRed = this.is_dark ? "#cf3636" : "#E74242"
            const highlight = this.is_dark ? "rgba(255, 236, 48, 0.7)" : "#FFEC30"
            const safeGreen = this.is_dark ? "rgba(1, 171, 108, 0.7)" : "#01ab6c"
            const green = this.is_dark ? "rgba(38, 166, 154, 0.4)" : "rgb(171, 235, 198)"
            const gray = this.is_dark ? "rgba(100, 110, 130, 0.5)" : "#E0E0E0"
            const darkgray = this.is_dark ? "rgba(80, 90, 110, 0.4)" : "#d9d9d9"
            const globalCompositeOperation = ctx.globalCompositeOperation
            const globalAlpha = ctx.globalAlpha

            plotA.forEach(each => {
                const { startIdx, endIdx, entryDirection, entryPoint, rsi, entryStoploss, entryTarget, pendingTarget, safeEntry, safeTarget, flashSide, flashTarget, tradedVolume, fractalHigh, fractalLow } = each

                var highlightEntry = false

                if (entryDirection) {
                    if (entryDirection === "BUY") {
                        if (rsi > 50 && rsi < 95) {
                          highlightEntry = true
                        }
                    } else if (entryDirection === "SELL") {
                       if (rsi < 50 && rsi > 5) {
                         highlightEntry = true
                       }
                    }

                    ctx.save()

                    if (this.show_pending_target) {
                        if (pendingTarget > 0) {
                          // Draw Shadow Area
                          ctx.beginPath()
                          ctx.fillStyle = this.hexToRGBA(darkgray, fillOpacity)
                          ctx.strokeStyle = this.hexToRGBA(darkgray, strokeOpacity)
                          ctx.globalAlpha = fillOpacity
                          ctx.globalCompositeOperation = "xor"
                          ctx.rect((startIdx), entryDirection === 'BUY' ? layout.$2screen(entryTarget) : layout.$2screen(pendingTarget), (endIdx - startIdx), entryDirection === 'BUY' ? layout.$2screen(pendingTarget) - layout.$2screen(entryTarget) : layout.$2screen(entryTarget) - layout.$2screen(pendingTarget))
                          ctx.fill()
                          ctx.stroke()
                          ctx.closePath()
                        }
                    }

                    ctx.globalCompositeOperation = globalCompositeOperation
                    ctx.globalAlpha = globalAlpha

                    if (this.show_safe_target) {
                        if (safeEntry > 0) {
                          // Draw Safe Entry Area
                          ctx.beginPath()
                          ctx.fillStyle = this.hexToRGBA(safeGreen, fillOpacity)
                          ctx.strokeStyle = this.hexToRGBA(red, strokeOpacity)
                          ctx.globalAlpha = fillOpacity
                          ctx.globalCompositeOperation = "xor"
                          ctx.rect((startIdx), entryDirection === 'BUY' ? layout.$2screen(safeEntry) : layout.$2screen(safeTarget), (endIdx - startIdx), entryDirection === 'BUY' ? layout.$2screen(safeTarget) - layout.$2screen(safeEntry) : layout.$2screen(safeEntry) - layout.$2screen(safeTarget))
                          ctx.fill()
                          ctx.stroke()
                          ctx.closePath()
                        }
                    }

                    if (this.show_immediate_target) {
                        var lineWidth = ctx.lineWidth
                        ctx.lineWidth = 1
                        ctx.beginPath()
                        ctx.strokeStyle = this.hexToRGBA(flashSide === 'BUY' ? darkGreen : darkRed, 1)
                        ctx.globalAlpha = fillOpacity
                        ctx.globalCompositeOperation = "xor"
                        ctx.rect((startIdx), entryDirection === 'BUY' ? layout.$2screen(flashTarget) : layout.$2screen(flashTarget), (endIdx - startIdx), entryDirection === 'BUY' ? layout.$2screen(flashTarget) - layout.$2screen(flashTarget) : layout.$2screen(flashTarget) - layout.$2screen(flashTarget))
                        ctx.stroke()
                        ctx.closePath()
                        ctx.lineWidth = lineWidth
                    }

                    // Draw Green Area
                    ctx.beginPath()
                    ctx.fillStyle = this.hexToRGBA(green, fillOpacity)
                    ctx.strokeStyle = this.hexToRGBA(green, strokeOpacity)
                    ctx.globalAlpha = fillOpacity
                    ctx.globalCompositeOperation = "xor"
                    ctx.rect((startIdx), entryDirection === 'BUY' ? layout.$2screen(entryPoint) : layout.$2screen(entryTarget), (endIdx - startIdx), entryDirection === 'BUY' ? layout.$2screen(entryTarget) - layout.$2screen(entryPoint) : layout.$2screen(entryPoint) - layout.$2screen(entryTarget))
                    ctx.fill()
                    ctx.stroke()
                    ctx.closePath()

                    // Draw Red Area
                    ctx.beginPath()
                    ctx.fillStyle = this.hexToRGBA(red, fillOpacity)
                    ctx.strokeStyle = this.hexToRGBA(red, strokeOpacity)
                    ctx.globalCompositeOperation = ""
                    ctx.globalAlpha = fillOpacity
                    ctx.rect((startIdx), entryDirection === 'BUY' ? layout.$2screen(entryStoploss) : layout.$2screen(entryPoint), (endIdx - startIdx), entryDirection === 'BUY' ? layout.$2screen(entryPoint) - layout.$2screen(entryStoploss) : layout.$2screen(entryStoploss) - layout.$2screen(entryPoint))
                    ctx.fill()
                    ctx.stroke()
                    ctx.closePath()

                    if (this.show_highlight_entry) {
                        // Highlight Entry Area
                        ctx.beginPath()
                        ctx.strokeStyle = this.hexToRGBA(highlightEntry ? darkRed : red, strokeOpacity)
                        ctx.fillStyle = this.hexToRGBA(highlightEntry ? darkRed : red, fillOpacity)
                        ctx.globalAlpha = strokeOpacity
                        ctx.globalCompositeOperation = "xor"
                        ctx.rect((startIdx), entryDirection === 'BUY' ? layout.$2screen(entryStoploss) : layout.$2screen(entryPoint), (endIdx - startIdx), entryDirection === 'BUY' ? layout.$2screen(entryPoint) - layout.$2screen(entryStoploss) : layout.$2screen(entryStoploss) - layout.$2screen(entryPoint))
                        ctx.fill()
                        ctx.stroke()
                        ctx.closePath()

                        if (highlightEntry && lastEntry.endIdx === endIdx) {
                          // Highlight Entry Area
                          ctx.beginPath()
                          ctx.strokeStyle = this.hexToRGBA(highlight, strokeOpacity)
                          ctx.fillStyle = this.hexToRGBA(highlight, fillOpacity)
                          ctx.globalAlpha = strokeOpacity
                          ctx.globalCompositeOperation = ""
                          ctx.rect((endIdx), entryDirection === 'BUY' ? layout.$2screen(entryStoploss) : layout.$2screen(entryPoint), (endIdx), entryDirection === 'BUY' ? layout.$2screen(entryPoint) - layout.$2screen(entryStoploss) : layout.$2screen(entryStoploss) - layout.$2screen(entryPoint))
                          ctx.fill()
                          ctx.stroke()
                          ctx.closePath()
                        }
                    }

                    ctx.globalAlpha = 1
                    ctx.restore()
                }
            })

            if (canvasClip) {
              ctx.restore()
            }
            if (this.price_line) this.price.draw(ctx, plotA)
        },

        draw_label(ctx, x, y, labelText) {
            ctx.fillStyle = this.label_color
            ctx.font = this.new_font
            ctx.textAlign = 'center'
            ctx.fillText(labelText, x, y)
        },
        use_for() {
            return ['VT']
        },
        processVTSignals(candles, entry, loadTarget) {
            var i = 0, j = 0
            var riskRewardRatio = this.risk_reward_ratio
            var smaLen = this.sma_length
            var dcLen = this.dc_length
            var clearEntry = true
            var pendingTargetB = 0
            var pendingTargetS = 0

            var lastEntry
            var lastCandle

            var sma = 0
            var dcHigh = 0
            var dcLow = 0
            var dcMid = 0
            var entryDirection = ""
            var entryPoint = 0
            var entrySL = 0
            var entryTarget = 0
            var signal = {}
            var blackCandle
            var trendChanged
            var prev
            var starFormed
            var blackCandleFormed
            var fractalHigh
            var fractalLow
            var activated = false
            var flashActivated = false
            var cmp = candles && candles.length > 0 ? candles[candles.length - 1][4] : 0
            var data = [];
            var startIndex = 0
            var i = 0
            var kuchiSize = 0;

            if (!loadTarget)
                startIndex = candles.length - 30

            for (var p of candles) {
                let tradeTime = p[0]
                let open = p[1]
                let high = p[2]
                let low = p[3]
                let close = p[4]
                var now = { date: tradeTime, open: open, high: high, low: low, close: close }

                if (i >= smaLen) {
                  for (var idx = 0; idx < smaLen; idx++) {
                    var smaIndex = i - idx
                    if (!sma)
                      sma = 0
                    if (smaIndex >= 0)
                      sma = sma + parseFloat(candles[smaIndex][4]) // close price
                    else
                      sma = sma + parseFloat(candles[0][4]) // close price of first candle
                  }

                  sma = parseFloat(sma / smaLen)
                } else {
                  sma = ""
                }

                dcHigh = 0
                dcLow = 0
                for (var idx = 0; idx < dcLen; idx++) {
                  var dcIndex = i - idx;
                  if (dcIndex >= 0) {
                    var highPrice = parseFloat(candles[dcIndex][2])
                    if (highPrice > dcHigh)
                      dcHigh = highPrice // high price
                  }
                }

                dcLow = 0
                for (var idx = 0; idx < dcLen; idx++) {
                  var dcIndex = i - idx
                  if (dcIndex >= 0) {
                    var lowPrice = parseFloat(candles[dcIndex][3])
                    if (dcLow === 0 || lowPrice < dcLow)
                      dcLow = lowPrice // low price
                  }
                }

                dcMid = dcLow + Math.abs((dcHigh - dcLow) / 2)
                now.dcHigh = dcHigh
                now.dcLow = dcLow

                now.sma = sma
                if (now.fractalHigh) fractalHigh = now.fractalHigh
                if (now.fractalLow) fractalLow = now.fractalLow

                var candleSize = Math.abs(high - low)
                var bodySize = Math.abs(open - close)

                if (!prev) {
                    prev = now
                    prev.smaColor = ""
                }
                if(now.sma > prev.sma) {
                    now.smaColor = "GREEN"
                } else {
                    now.smaColor = "RED"
                }
                if (!now.tradedVolume) {
                    now.tradedVolume = 0
                }
                if (!now.kuchiSize) {
                    now.kuchiSize = 0
                }
                if (candleSize === 0) {
                    blackCandle = false
                    now.blackCandle = blackCandle
                } else {
                    if(bodySize <= (candleSize / 2)) {
                        blackCandle = true
                        now.blackCandle = blackCandle
                        now.kuchiSize = candleSize - bodySize
                    } else {
                        blackCandle = false
                        now.blackCandle = blackCandle
                    }
                }


                var p_open = Number(prev.open)
                var p_high = Number(prev.high)
                var p_low = Number(prev.low)
                var p_close = Number(prev.close)

                if (prev.blackCandle) {
                    var wick1 = 0
                    var wick2 = 0
                    var wickSize = 0
                    if (p_open > p_close) {
                        wick1 = p_high - p_open
                        wick2 = p_close - p_low
                    } else {
                        wick1 = p_high - p_close
                        wick2 = p_open - p_low
                    }
                    if (wick1 > wick2) {
                        wickSize = wick1
                    } else {
                        wickSize = wick2
                    }
                    if (close >= p_high) {
                        var flashTarget = p_high + Number(wickSize * riskRewardRatio)
                        var flashTarget1 = p_high + Number(wickSize * 1)
                        var flashTarget2 = p_high + Number(wickSize * 2)
                        var flashReverseTarget = p_low - Number(wickSize * riskRewardRatio)
                        var flashReverseTarget1 = p_low - Number(wickSize * 1)
                        var flashReverseTarget2 = p_low - Number(wickSize * 2)
                        now.flashTradeStart = true
                        now.flashTrade = true
                        now.flashSide = "BUY"
                        now.flashEntry = Number(p_high)
                        now.flashTarget = Number(flashTarget)
                        now.flashTarget1 = Number(flashTarget1)
                        now.flashTarget2 = Number(flashTarget2)
                        now.flashReverseTarget = Number(flashReverseTarget)
                        now.flashReverseTarget1 = Number(flashReverseTarget1)
                        now.flashReverseTarget2 = Number(flashReverseTarget2)
                        now.flashStoploss = Number(p_low)
                    } else if (close <= p_low) {
                        var flashTarget = p_low - Number(wickSize * riskRewardRatio)
                        var flashTarget1 = p_low - Number(wickSize * 1)
                        var flashTarget2 = p_low - Number(wickSize * 2)
                        var flashReverseTarget = p_high + Number(wickSize * riskRewardRatio)
                        var flashReverseTarget1 = p_high + Number(wickSize * 1)
                        var flashReverseTarget2 = p_high + Number(wickSize * 2)
                        now.flashTrade = true
                        now.flashTradeStart = true
                        now.flashSide = "SELL"
                        now.flashEntry = Number(p_low)
                        now.flashTarget = Number(flashTarget)
                        now.flashTarget1 = Number(flashTarget1)
                        now.flashTarget2 = Number(flashTarget2)
                        now.flashReverseTarget = Number(flashReverseTarget)
                        now.flashReverseTarget1 = Number(flashReverseTarget1)
                        now.flashReverseTarget2 = Number(flashReverseTarget2)
                        now.flashStoploss = Number(p_high)
                    } else {
                        now.flashTrade = false
                        now.flashTradeStart = false
                        now.flashSide = ""
                        now.flashEntry = 0
                        now.flashTarget = 0
                        now.flashTarget1 = 0
                        now.flashTarget2 = 0
                        now.flashReverseTarget = 0
                        now.flashReverseTarget1 = 0
                        now.flashReverseTarget2 = 0
                        now.flashStoploss = 0
                    }
                }

                if (!now.flashTrade) {
                    now.flashTrade = prev.flashTrade
                    now.flashTradeStart = false
                    now.flashSide = prev.flashSide
                    now.flashTarget = prev.flashTarget
                    now.flashTarget1 = prev.flashTarget1
                    now.flashTarget2 = prev.flashTarget2
                    now.flashReverseTarget = prev.flashReverseTarget
                    now.flashReverseTarget1 = prev.flashReverseTarget1
                    now.flashReverseTarget2 = prev.flashReverseTarget2
                }
                if(now.smaColor === prev.smaColor) {
                    now.trendChanged = false
                } else {
                    trendChanged = true
                    now.trendChanged = trendChanged
                    starFormed = false
                    blackCandleFormed = false
                    entryDirection = ""
                    entryPoint = 0
                    entrySL = 0
                    entryTarget = 0
                }

                if (now.trendChanged != prev.trendChanged) {
                  starFormed = false
                }

                if (prev.blackCandle && now.trendChanged) {
                    starFormed = true
                    blackCandleFormed = true
                    if (now.smaColor === "GREEN") {
                        entryDirection = "BUY"
                        entryPoint = prev.high
                        entrySL = prev.low
                        entryTarget = entryPoint + Number(( entryPoint - entrySL) * riskRewardRatio)
                        kuchiSize = kuchiSize + now.kuchiSize
                    } else {
                        entryDirection = "SELL"
                        entryPoint = prev.low
                        entrySL = prev.high
                        entryTarget = entryPoint - Number(( entrySL - entryPoint ) * riskRewardRatio)
                        kuchiSize = kuchiSize + now.kuchiSize
                    }
                } else {
                    starFormed = false
                }

                if ((starFormed || trendChanged) && now.blackCandle) {
                    blackCandleFormed = true
                    if (now.smaColor === "GREEN") {
                        entryDirection = "BUY"
                        if (entryPoint === 0)
                            entryPoint = high
                        if (entrySL === 0)
                            entrySL = low
                        if (low < entrySL)
                            entrySL = low
                        if (high > entryPoint)
                            entryPoint = high
                        entryTarget = entryPoint + Number(( entryPoint - entrySL) * riskRewardRatio)
                        kuchiSize = kuchiSize + now.kuchiSize
                    } else {
                        entryDirection = "SELL"
                        if (entryPoint === 0)
                            entryPoint = low
                        if (entrySL === 0)
                            entrySL = high
                        if (high > entrySL)
                            entrySL = high
                        if (low < entryPoint)
                            entryPoint = low
                        entryTarget = entryPoint - Number(( entrySL - entryPoint ) * riskRewardRatio)
                        kuchiSize = kuchiSize + now.kuchiSize
                    }
                }

                if ((starFormed || trendChanged) && blackCandleFormed && !now.blackCandle) {
                    trendChanged = false
                    now.isEntry = true
                }

                if (now.isEntry) {
                    //now.trendChanged = trendChanged
                    now.entryDirection = entryDirection
                    now.entryPoint = Number(entryPoint)
                    now.entryStoploss = Number(entrySL)
                    now.entryTarget = Number(entryTarget)

                    if (entry && entryDirection) {
                        var alert = ""
                        entry.call = entryDirection
                        entry.entry = entryPoint
                        entry.stoploss = entrySL
                        entry.target = Number(entryTarget)
                        entry.latesttrend = now.date
                        entry.index = i
                        entry.cmp = cmp
                        entry.tradedVolume = Math.abs(kuchiSize)
                        var targetIndex = candles.length - 10

                        if (entryDirection === "BUY") {
                          if (cmp >= high || high >= now.dcHigh) {
                              alert = "TARGET"
                          } else if (cmp <= now.dcMid || low <= now.dcMid
                              || cmp <= entrySL) {
                              alert = "WARN"
                          } else if (cmp <= now.dcLow || low <= now.dcLow
                              || now.trendChanged) {
                              alert = "STOP"
                          }

                          if ((cmp < entryPoint && cmp > entrySL)
                              || (cmp >= entryPoint && cmp < entryTarget)
                              && ("TARGET" === alert  || alert === "")) {
                              activated = true
                          } else {
                              activated = false
                          }
                        } else if (entryDirection === "SELL") {
                          if (cmp >= now.dcHigh || high >= now.dcHigh || now.trendChanged) {
                              alert = "STOP"
                          } else if (cmp >= now.dcMid || high >= now.dcMid
                              || cmp >= entrySL) {
                              alert = "WARN"
                          } else if (cmp <= now.dcLow || low <= now.dcLow) {
                              alert = "TARGET"
                          }

                          if ((cmp > entryPoint && cmp < entrySL)
                              || (cmp <= entryPoint && cmp > entryTarget)
                              && ("TARGET" === alert  || alert === "")) {
                              activated = true
                          } else {
                              activated = false
                          }
                        }
                    }

                    if (!now.blackCandle) {
                        trendChanged = false
                        blackCandleFormed = false
                        starFormed = false
                        entryDirection = ""
                        entrySL = 0
                        entryPoint = 0
                        entryTarget = 0
                        kuchiSize = 0
                    }
                }

                if (entry.call === "BUY") {
                  if (close >= entry.target || high >= entry.target) {
                    activated = false
                  }
                } else if (entry.call === "SELL") {
                   if (close <= entry.target || low <= entry.target) {
                     activated = false
                   }
                }

                if (now.flashTrade) {
                    entry.flashSide = now.flashSide
                    entry.flashEntry = now.flashEntry
                    entry.flashStoploss = now.flashStoploss
                    entry.flashTarget = Number(now.flashTarget)
                    entry.latestFlashTrend = now.date

                    if (entry.flashSide === "BUY") {
                      if ((close < now.flashEntry && close > now.flashStoploss)
                          || (close >= now.flashEntry && close < now.flashTarget)) {
                          flashActivated = true
                      } else {
                          flashActivated = false
                      }
                      if (close >= entry.flashTarget || high >= entry.flashTarget) {
                        flashActivated = false
                      }
                    } else if (entry.flashSide === "SELL") {
                      if ((close > now.flashEntry && close < now.flashStoploss)
                          || (close <= now.flashEntry && close > now.flashTarget)) {
                          flashActivated = true
                      } else {
                          flashActivated = false
                      }
                      if (close <= entry.flashTarget || low <= entry.flashTarget) {
                        flashActivated = false
                      }
                    }
                }
                data[i] = now
                prev = now
                i++
            }

            data.entry = entry
            entry.activated = activated
            entry.flashActivated = flashActivated
            return data
        },
        hexToRGBA(inputHex, opacity) {
            const hex = inputHex.replace("#", "")
            if (inputHex.indexOf("#") > -1 && (hex.length === 3 || hex.length === 6)) {

                const multiplier = (hex.length === 3) ? 1 : 2

                const r = parseInt(hex.substring(0, 1 * multiplier), 16)
                const g = parseInt(hex.substring(1 * multiplier, 2 * multiplier), 16)
                const b = parseInt(hex.substring(2 * multiplier, 3 * multiplier), 16)

                const result = `rgba(${ r }, ${ g }, ${ b }, ${ opacity })`

                return result
            }
            return inputHex
        }
    }
}
</script>
